// Window chrome — traffic lights and the active tab.
import React from 'react';
import { TerminalIcon } from './Icons';

const TerminalHeader = () => (
  <div className="window-bar">
    <div className="window-bar-left">
      <div className="traffic-lights">
        <span className="light light-red" />
        <span className="light light-yellow" />
        <span className="light light-green" />
      </div>
      <div className="window-tab">
        <TerminalIcon />
        <span>attuul@portfolio — ~</span>
      </div>
    </div>
    <div className="window-bar-right">
      <span>zsh</span>
      <span>v2.0</span>
    </div>
  </div>
);

export default TerminalHeader;
